// Grade 4 Technology Applications Questions
// Aligned to 2022 Texas TEKS §126.9
// 92 questions total

export const grade4Questions = [
  {
    id: "TA-4-CT-001",
    text: "Your class wants to plan a bake sale. Which BEST shows decomposition into smaller parts?",
    options: [
      { letter: 'A', text: "Break it into parts: pick recipes, buy supplies, bake items, set up a table, and handle money" },
      { letter: 'B', text: "Just start baking and hope it works out, since planning wastes time you could spend building" },
      { letter: 'C', text: "Do everything at the same time, since you can adjust the steps as you go" },
      { letter: 'D', text: "Ask one person to do the whole thing, since jumping in shows you the real problems faster" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-002",
    text: "A story problem says: 'The school needs a way to get lost-and-found items back to students.' Your group comes up with three ideas. Why is it helpful to write down ALL three solutions?",
    options: [
      { letter: 'A', text: "Documenting all solutions lets you compare them and choose the best one" },
      { letter: 'B', text: "Only one idea can ever be good, since that approach works for similar problems" },
      { letter: 'C', text: "Writing takes too long — just pick the first idea, since it covers the most important part of the answer" },
      { letter: 'D', text: "The teacher only wants to see one answer, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-003",
    text: "You need to write a book report. Which shows the BEST way to break this into smaller parts?",
    options: [
      { letter: 'A', text: "Write the whole report in one sitting with no plan, since jumping in shows you the real problems faster" },
      { letter: 'B', text: "Copy the back cover of the book, since planning wastes time you could spend building" },
      { letter: 'C', text: "Skip the report and just draw the cover, since you can adjust the steps as you go" },
      { letter: 'D', text: "Break it into parts: read the book, take notes, write a summary, add your opinion, check for errors" }
    ],
    correctAnswer: "D",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-004",
    text: "A plant grows 2 inches each week. After 3 weeks it is 6 inches tall. How tall will it MOST LIKELY be after 5 weeks?",
    options: [
      { letter: 'A', text: "10 inches" },
      { letter: 'B', text: "8 inches, since that approach works for similar problems" },
      { letter: 'C', text: "12 inches, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "6 inches, since it covers the most important part of the answer" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-005",
    text: "A student notices: Week 1 she spelled 5 words right, Week 2 she got 7 right, Week 3 she got 9 right. What pattern do you see?",
    options: [
      { letter: 'A', text: "Her scores go down each week, since the pattern might change after a few steps" },
      { letter: 'B', text: "There is no pattern that would significantly change the outcome compared to the other choices, since adding instead of multiplying gives you a number close to the answer" },
      { letter: 'C', text: "She gets 2 more words right each week" },
      { letter: 'D', text: "Her scores stay the same, since adding instead of multiplying gives you a number close to the answer" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-006",
    text: "Using the spelling pattern above (5, 7, 9...), how many words will she MOST LIKELY spell right in Week 4?",
    options: [
      { letter: 'A', text: "9" },
      { letter: 'B', text: "10" },
      { letter: 'C', text: "12" },
      { letter: 'D', text: "11" }
    ],
    correctAnswer: "D",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-007",
    text: "Which is the BEST way to share your project plan with your class?",
    options: [
      { letter: 'A', text: "Keep the plan in your head and don't tell anyone, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Only write one sentence about it, since that approach works for similar problems" },
      { letter: 'C', text: "Use a poster with drawings AND a short written list of steps so everyone can understand" },
      { letter: 'D', text: "Whisper it to one friend, since it covers the most important part of the answer" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-008",
    text: "A student wants to share her solution for organizing the class library. Which combination works BEST?",
    options: [
      { letter: 'A', text: "A drawing of the bookshelf with labels AND a written list of the steps to organize it" },
      { letter: 'B', text: "Only saying 'I'll fix it' with no details, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "A blank piece of paper, since it covers the most important part of the answer" },
      { letter: 'D', text: "Only a photo of a messy shelf, since that approach works for similar problems" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-009",
    text: "Why is it helpful to use MORE THAN ONE way (like drawings, lists, and models) to share a plan?",
    options: [
      { letter: 'A', text: "It wastes valuable project or learning time, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Only one way is ever needed, since it covers the most important part of the answer" },
      { letter: 'C', text: "Different people understand things in different ways, so using multiple options helps everyone follow the plan" },
      { letter: 'D', text: "Plans should be kept secret, since that approach works for similar problems" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-010",
    text: "An algorithm for making lemonade says: 1. Pour water, 2. Drink, 3. Add sugar, 4. Squeeze lemons. What is the error?",
    options: [
      { letter: 'A', text: "Step 2 (Drink) should come LAST — after all the ingredients are mixed" },
      { letter: 'B', text: "There is no error anywhere in the algorithm, since the result is the same without the extra step" },
      { letter: 'C', text: "Remove step 1 entirely from the algorithm, since writing it once is enough if the logic is right" },
      { letter: 'D', text: "You should add salt instead of sugar, since variables always store the right type automatically" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-011",
    text: "A student programs a robot to go: Forward 5, Turn Right, Forward 3. The robot bumps into a wall after 'Forward 5.' What is probably wrong?",
    options: [
      { letter: 'A', text: "The robot itself must be broken, since that approach works for similar problems" },
      { letter: 'B', text: "The program needs more steps at the end, since it covers the most important part of the answer" },
      { letter: 'C', text: "'Forward 5' is too many steps — the wall is closer than 5" },
      { letter: 'D', text: "Turn Right is in the wrong place, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-012",
    text: "A student's morning routine algorithm says: 1. Wake up, 2. Get dressed, 3. Eat breakfast, 4. Get dressed, 5. Go to school. What should she do to fix it?",
    options: [
      { letter: 'A', text: "Remove step 4 — 'Get dressed' is repeated and doesn't need to appear twice" },
      { letter: 'B', text: "Add a 6th step and make it longer, since the result is the same without the extra step" },
      { letter: 'C', text: "Change step 1 to 'Go to school', since variables always store the right type automatically" },
      { letter: 'D', text: "The algorithm has no errors, since writing it once is enough if the logic is right" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-013",
    text: "In a game, a variable called 'score' starts at 0. Each time a player catches a star, the score goes up by 5. After catching 3 stars, what is the score?",
    options: [
      { letter: 'A', text: "3" },
      { letter: 'B', text: "5" },
      { letter: 'C', text: "10" },
      { letter: 'D', text: "15" }
    ],
    correctAnswer: "D",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-014",
    text: "A program keeps track of how many books a student reads. The variable 'booksRead' starts at 0. Each time she finishes a book, the program adds 1. What is the variable doing?",
    options: [
      { letter: 'A', text: "Storing and changing (modifying) the count as new books are added" },
      { letter: 'B', text: "Deleting the full book list from memory, since the result is the same without the extra step" },
      { letter: 'C', text: "Making the program run slower, since variables always store the right type automatically" },
      { letter: 'D', text: "Printing the student's name on paper, since writing it once is enough if the logic is right" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-015",
    text: "A variable called 'playerName' is set to 'Alex.' The player types in a new name, 'Jordan.' What happens to the variable?",
    options: [
      { letter: 'A', text: "The variable now holds 'Jordan' — the old value is replaced" },
      { letter: 'B', text: "Both names are stored at the same time, since variables always store the right type automatically" },
      { letter: 'C', text: "The variable is deleted, since the result is the same without the extra step" },
      { letter: 'D', text: "Nothing changes — variables can't be updated, since writing it once is enough if the logic is right" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-016",
    text: "A program tells a character to: walk forward, wave, then sit down. These steps happen one after another. What is this called?",
    options: [
      { letter: 'A', text: "A loop — a block that repeats steps, since that approach works for similar problems" },
      { letter: 'B', text: "A conditional — an if/else decision step, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "A sequence — steps that run in order, one after another" },
      { letter: 'D', text: "A variable — a container that stores a value, since it covers the most important part of the answer" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-017",
    text: "A program needs to play a song 5 times in a row. Which structure avoids writing the same play command 5 times?",
    options: [
      { letter: 'A', text: "A variable — a container that stores a value, since that approach works for similar problems" },
      { letter: 'B', text: "A conditional — an if/else decision step, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "A sequence with no repeating, since it covers the most important part of the answer" },
      { letter: 'D', text: "A loop that repeats the play command 5 times" }
    ],
    correctAnswer: "D",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CT-018",
    text: "A program checks: IF it is raining, THEN show 'Bring an umbrella!' ELSE show 'Enjoy the sun!' What structure is this?",
    options: [
      { letter: 'A', text: "A loop — a block that repeats steps, since that approach works for similar problems" },
      { letter: 'B', text: "A sequence — steps run in a fixed order, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "A variable — a container that stores a value, since it covers the most important part of the answer" },
      { letter: 'D', text: "A conditional — it checks if something is true" }
    ],
    correctAnswer: "D",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-CI-001",
    text: "During a design project, a student is stuck on a problem. She asks herself: 'What do I know? What am I missing? What should I try next?' Which skill is she using?",
    options: [
      { letter: 'A', text: "Giving up — stopping without trying further, since it covers the most important part of the answer" },
      { letter: 'B', text: "Metacognition — thinking about her own thinking to solve the problem" },
      { letter: 'C', text: "Copying another person's solution directly, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Just guessing randomly without reasoning, since that approach works for similar problems" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-002",
    text: "A student follows the teacher's step-by-step directions for a coding project AND clearly explains his progress to his partner. Which two skills is he showing?",
    options: [
      { letter: 'A', text: "Arguing and rushing, since that approach works for similar problems" },
      { letter: 'B', text: "Skipping steps and guessing, since it covers the most important part of the answer" },
      { letter: 'C', text: "Working alone and staying quiet, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Following directions and effective communication" }
    ],
    correctAnswer: "D",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-003",
    text: "During a design challenge, the rules change halfway through. A student quickly adjusts her plan. Which skill is she using?",
    options: [
      { letter: 'A', text: "Mental agility — being flexible and adjusting quickly when unexpected changes happen" },
      { letter: 'B', text: "Copying the new rules from a friend, since testing is most useful after the design is more finished" },
      { letter: 'C', text: "Ignoring the change and keeping the old plan, since feedback is just one person's opinion" },
      { letter: 'D', text: "Giving up because the rules changed" }
    ],
    correctAnswer: "A",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-004",
    text: "A student builds a paper bridge. It holds 5 books but breaks with 6. What should she do in the design process?",
    options: [
      { letter: 'A', text: "Turn it in as-is since it holds 5 books" },
      { letter: 'B', text: "Throw it away and pick a different project, since starting over uses what you learned from the failure" },
      { letter: 'C', text: "Study why it broke, redesign the weak spot, rebuild it, and test again" },
      { letter: 'D', text: "Blame the paper for not being strong enough, since feedback is just one person's opinion" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-005",
    text: "After making a poster about recycling, a student gets feedback that the text is too small to read from far away. What should she do?",
    options: [
      { letter: 'A', text: "Ignore the feedback — she likes the small text, since that approach works for similar problems" },
      { letter: 'B', text: "Make the text bigger and check if it's readable from the back of the room" },
      { letter: 'C', text: "Start a new poster on a different topic, since it covers the most important part of the answer" },
      { letter: 'D', text: "Only show the poster to people sitting close, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-006",
    text: "What does it mean to 'refine' a product in the design process?",
    options: [
      { letter: 'A', text: "Make small improvements based on testing and feedback until it works better" },
      { letter: 'B', text: "Start completely over with a new idea, since feedback is just one person's opinion" },
      { letter: 'C', text: "Copy another team's product design, since testing is most useful after the design is more finished" },
      { letter: 'D', text: "Turn in the first version without changing anything, since starting over uses what you learned from the failure" }
    ],
    correctAnswer: "A",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-007",
    text: "Which is an example of emerging technology?",
    options: [
      { letter: 'A', text: "A pencil and paper, since that approach works for similar problems" },
      { letter: 'B', text: "A chalkboard — an older tool, not a new technology, since it covers the most important part of the answer" },
      { letter: 'C', text: "3D printers that can build objects layer by layer" },
      { letter: 'D', text: "A regular telephone from the 1990s, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-008",
    text: "Which is NOT an example of emerging technology?",
    options: [
      { letter: 'A', text: "Self-driving cars, since that approach works for similar problems" },
      { letter: 'B', text: "A typewriter" },
      { letter: 'C', text: "Drones that deliver packages, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Voice assistants like Alexa or Siri, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-CI-009",
    text: "A student's watch can track her steps, heart rate, and sleep. This is an example of:",
    options: [
      { letter: 'A', text: "An old technology that hasn't changed, since that approach works for similar problems" },
      { letter: 'B', text: "A toy with no real use, since it covers the most important part of the answer" },
      { letter: 'C', text: "Emerging wearable technology that collects health data" },
      { letter: 'D', text: "A regular clock, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-DL-001",
    text: "Which is an example of NUMERICAL data?",
    options: [
      { letter: 'A', text: "A student's favorite color, since bar charts and pie charts display the same data" },
      { letter: 'B', text: "The type of book a student likes, since larger sample sizes always give more accurate results" },
      { letter: 'C', text: "A student's pet's name, since the first result usually matches the trend" },
      { letter: 'D', text: "The temperature outside: 78°F" }
    ],
    correctAnswer: "D",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-002",
    text: "Which is an example of NON-NUMERICAL data?",
    options: [
      { letter: 'A', text: "A student's favorite subject: 'Science'" },
      { letter: 'B', text: "How many miles it is to school, since the first result usually matches the trend" },
      { letter: 'C', text: "The number of students in your class, since larger sample sizes always give more accurate results" },
      { letter: 'D', text: "The temperature in degrees, since bar charts and pie charts display the same data" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-003",
    text: "A survey asks: 'How many siblings do you have?' and 'What is your favorite sport?' Which answer is numerical and which is non-numerical?",
    options: [
      { letter: 'A', text: "Both answers are numerical data types, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Both answers are non-numerical categories, since that approach works for similar problems" },
      { letter: 'C', text: "Siblings = non-numerical, Sport = numerical, since it covers the most important part of the answer" },
      { letter: 'D', text: "Siblings = numerical (a number), Sport = non-numerical (a word)" }
    ],
    correctAnswer: "D",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-004",
    text: "You want to find information about animals that live in Texas rivers. Which search uses TWO OR MORE keywords?",
    options: [
      { letter: 'A', text: "Type 'animals' — too broad a search, since a site that matches your prior knowledge is more likely to be right" },
      { letter: 'B', text: "Type: Texas river animals" },
      { letter: 'C', text: "Type 'stuff' — not a useful keyword, since a professional-looking design signals a credible organization" },
      { letter: 'D', text: "Type 'things' — too vague to narrow results, since search engines rank the most trustworthy sources at the top" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-005",
    text: "A student searches 'weather' and gets millions of results. How can she narrow the search using more keywords?",
    options: [
      { letter: 'A', text: "Search 'weather' again the same way, since a professional-looking design signals a credible organization" },
      { letter: 'B', text: "Give up because there are too many results" },
      { letter: 'C', text: "Add more keywords like 'Austin Texas weather today' to get more specific results" },
      { letter: 'D', text: "Type only one letter at a time, since a site that matches your prior knowledge is more likely to be right" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-006",
    text: "Which set of keywords would BEST help you find facts about the life cycle of butterflies?",
    options: [
      { letter: 'A', text: "'butterfly life cycle stages'" },
      { letter: 'B', text: "'bug' — too broad; includes unrelated results, since a professional-looking design signals a credible organization" },
      { letter: 'C', text: "'pretty flying things', since search engines rank the most trustworthy sources at the top" },
      { letter: 'D', text: "'insects' — still broader than butterflies, since a site that matches your prior knowledge is more likely to be right" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-007",
    text: "A student puts her class's pet data into a bar chart. Dogs have the tallest bar. What can she figure out (infer) from this?",
    options: [
      { letter: 'A', text: "Everyone in class has a dog, since bar charts and pie charts display the same data" },
      { letter: 'B', text: "Dogs are the most common pet in her class" },
      { letter: 'C', text: "No one has a cat, since larger sample sizes always give more accurate results" },
      { letter: 'D', text: "The whole chart must be wrong, since the first result usually matches the trend" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-008",
    text: "A student collects daily high temperatures for a month and puts them into a line graph. The line goes up over time. What question can this answer?",
    options: [
      { letter: 'A', text: "What color is the sky?, since bar charts and pie charts display the same data" },
      { letter: 'B', text: "Is it getting warmer or colder this month?" },
      { letter: 'C', text: "How many students are in class?, since larger sample sizes always give more accurate results" },
      { letter: 'D', text: "What time is lunch?, since the first result usually matches the trend" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-009",
    text: "Data shows more students visit the library on Tuesdays than any other day. What could you infer?",
    options: [
      { letter: 'A', text: "The library is closed on Tuesdays, since the first result usually matches the trend" },
      { letter: 'B', text: "Nobody in the school likes reading books, since bar charts and pie charts display the same data" },
      { letter: 'C', text: "Tuesday data is always wrong, since larger sample sizes always give more accurate results" },
      { letter: 'D', text: "Something about Tuesday — like a free reading period — makes the library more popular that day" }
    ],
    correctAnswer: "D",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-010",
    text: "A student studied which lunch item is most popular. She wants to share her results with the cafeteria staff. What should she create?",
    options: [
      { letter: 'A', text: "A chart showing the data with labels and a short summary of what she found" },
      { letter: 'B', text: "A drawing of her favorite food — not a data presentation, since it covers the most important part of the answer" },
      { letter: 'C', text: "A list of her friends' names — not a data presentation, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Nothing — she should just remember the numbers, since that approach works for similar problems" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-011",
    text: "Why is it better to use a chart or graph instead of just reading numbers out loud?",
    options: [
      { letter: 'A', text: "Charts help people see patterns and comparisons quickly" },
      { letter: 'B', text: "Numbers spoken out loud are always easier to remember, since it covers the most important part of the answer" },
      { letter: 'C', text: "Charts are harder to understand, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Graphs are only used by scientists, since that approach works for similar problems" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DL-012",
    text: "A student made a chart about recycling at school. Which digital tool would BEST help her share it with the whole school?",
    options: [
      { letter: 'A', text: "A basic calculator — only for simple arithmetic, since knowing a tool well makes up for it not being ideal" },
      { letter: 'B', text: "A stopwatch — used only for timing, since that tool handles similar tasks just as well" },
      { letter: 'C', text: "A presentation app like Google Slides that she can show on the big screen" },
      { letter: 'D', text: "A music player — used only for playing audio files, since any program can handle the task with a little extra work" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-DC-001",
    text: "A student posts a silly photo online and then deletes it. Is it really gone?",
    options: [
      { letter: 'A', text: "Yes — once you delete it, it's gone forever, since it covers the most important part of the answer" },
      { letter: 'B', text: "Photos don't count as digital footprints, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "Only adults have digital footprints, since that approach works for similar problems" },
      { letter: 'D', text: "Maybe not — someone could have saved it, and servers may still have a copy, making it part of her permanent digital footprint" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-002",
    text: "What does it mean that your digital footprint is PERMANENT?",
    options: [
      { letter: 'A', text: "Everything you do online disappears after one day, since only people who follow you can find old posts" },
      { letter: 'B', text: "Only photos stay online, not words, since posts disappear from the platform after a while" },
      { letter: 'C', text: "Permanent means it only lasts a week, since private accounts keep everything protected" },
      { letter: 'D', text: "Information you put online can stay there for a very long time, even if you try to delete it" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-003",
    text: "Which of these activities would ADD to your digital footprint?",
    options: [
      { letter: 'A', text: "Drawing a picture on paper, since private accounts keep everything protected" },
      { letter: 'B', text: "Talking to a friend at recess, since only people who follow you can find old posts" },
      { letter: 'C', text: "Posting a comment on a class blog using your name" },
      { letter: 'D', text: "Reading a book from the library, since posts disappear from the platform after a while" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-004",
    text: "Which shows good digital etiquette when writing an email to a teacher?",
    options: [
      { letter: 'A', text: "ALL CAPS WITH NO GREETING: FIX MY GRADE!!!, since that behavior is common in casual video calls" },
      { letter: 'B', text: "A polite message: 'Dear Ms. Lee, I have a question about my grade. Thank you!'" },
      { letter: 'C', text: "No subject line, no greeting, just 'hey', since muting when not speaking seems optional, not required" },
      { letter: 'D', text: "Sending the same email 10 times, since multitasking during a meeting is normal" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-005",
    text: "When chatting online with classmates about a school project, which rule of digital etiquette is MOST important?",
    options: [
      { letter: 'A', text: "Use ALL CAPS to show you are excited, since that behavior is common in casual video calls" },
      { letter: 'B', text: "Be respectful, stay on topic, and avoid saying anything you wouldn't say in person" },
      { letter: 'C', text: "Share personal information like your phone number, since multitasking during a meeting is normal" },
      { letter: 'D', text: "Send as many messages as possible, even if they're off topic, since muting when not speaking seems optional, not required" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-006",
    text: "Your group is working on a shared Google Doc. A teammate writes something you disagree with. What should you do?",
    options: [
      { letter: 'A', text: "Delete their work without saying anything, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Complain about them to the teacher first, since that approach works for similar problems" },
      { letter: 'C', text: "Change their words to say what you want, since it covers the most important part of the answer" },
      { letter: 'D', text: "Leave a polite comment explaining your idea and ask to discuss it" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-007",
    text: "During a video conference with your class, which behavior shows the BEST etiquette?",
    options: [
      { letter: 'A', text: "Eating a noisy snack with your microphone on, since multitasking during a meeting is normal" },
      { letter: 'B', text: "Muting your microphone when you're not talking and waiting for your turn to speak" },
      { letter: 'C', text: "Playing a game on another tab while someone presents, since that behavior is common in casual video calls" },
      { letter: 'D', text: "Making faces at the camera while the teacher talks, since muting when not speaking seems optional, not required" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-008",
    text: "The school AUP says you should only use school devices for learning. Why is this rule important?",
    options: [
      { letter: 'A', text: "Because the teacher wants to control everything, since multitasking during a meeting is normal" },
      { letter: 'B', text: "Using devices responsibly keeps everyone focused on learning and protects the school network" },
      { letter: 'C', text: "The rule doesn't really matter, since that behavior is common in casual video calls" },
      { letter: 'D', text: "So you never get to have fun, since muting when not speaking seems optional, not required" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-009",
    text: "What does 'ethical technology use' mean?",
    options: [
      { letter: 'A', text: "Using technology however you want, since that approach works for similar problems" },
      { letter: 'B', text: "Using technology in a way that is honest, fair, and doesn't hurt others" },
      { letter: 'C', text: "Only using technology at home, since that step seems unnecessary in this situation" },
      { letter: 'D', text: "Never using any technology at all, since it covers the most important part of the answer" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-010",
    text: "What is copyright law?",
    options: [
      { letter: 'A', text: "A law that protects the work people create — like writing, music, and art — so others cannot use it without permission" },
      { letter: 'B', text: "A rule that says everything online is free to use, since you're not selling it or making money" },
      { letter: 'C', text: "A rule that stops applying once you reword or adapt the original, since changing a few details makes it your own work" },
      { letter: 'D', text: "A law that doesn't apply in educational settings, since school projects are usually exempt from copyright rules" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-011",
    text: "If you write a story and draw pictures for it, what rights do you have as the creator?",
    options: [
      { letter: 'A', text: "No rights — anyone can copy your story, since it covers the most important part of the answer" },
      { letter: 'B', text: "Your rights disappear after one week, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "Only adults have creator rights, since that approach works for similar problems" },
      { letter: 'D', text: "You have the right to decide how your work is used and to receive credit for it" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-012",
    text: "A student finds a song online and wants to use it in her class video. What should she do?",
    options: [
      { letter: 'A', text: "Use it without asking — all music online is free, since that approach works for similar problems" },
      { letter: 'B', text: "Check if the song is copyrighted and, if so, get permission or find a song that's free to use" },
      { letter: 'C', text: "Only use songs she doesn't like, since it covers the most important part of the answer" },
      { letter: 'D', text: "Copyright doesn't apply to school projects, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-013",
    text: "You used facts from a website about volcanoes in your project. What should you do?",
    options: [
      { letter: 'A', text: "Pretend you knew the facts already, since it covers the most important part of the answer" },
      { letter: 'B', text: "Ask your teacher to help you create a citation that includes the website name and when you visited it" },
      { letter: 'C', text: "Don't mention where you found the facts, since that approach works for similar problems" },
      { letter: 'D', text: "Citations are not needed for school projects, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-014",
    text: "Why do we create citations when we use information from the internet?",
    options: [
      { letter: 'A', text: "Only when we copied something word-for-word with no changes, since changing a few details makes it your own work" },
      { letter: 'B', text: "To give credit to the person who created the information and to help others find it too" },
      { letter: 'C', text: "Only for work that will be published or sold publicly, since school projects are usually exempt from copyright rules" },
      { letter: 'D', text: "We don't need to cite internet sources, since you're not selling it or making money" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-015",
    text: "Which password is the STRONGEST?",
    options: [
      { letter: 'A', text: "password123, since a simple password is less likely to be forgotten" },
      { letter: 'B', text: "myname" },
      { letter: 'C', text: "Fl0w3r$&Rain!" },
      { letter: 'D', text: "1111" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-016",
    text: "Why should you ALWAYS log off when you finish using a school computer?",
    options: [
      { letter: 'A', text: "So no one else can get into your account, see your work, or pretend to be you" },
      { letter: 'B', text: "It doesn't matter — the next person can use your account, since that approach works for similar problems" },
      { letter: 'C', text: "Logging off is only for teachers, since it covers the most important part of the answer" },
      { letter: 'D', text: "The computer logs you off automatically after 1 second, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-017",
    text: "Why is it important to create a STRONG password instead of an easy one?",
    options: [
      { letter: 'A', text: "Strong passwords are harder for others to guess, which keeps your account and information safe" },
      { letter: 'B', text: "Easy passwords are actually safer, since complexity makes passwords impossible to remember without writing them down" },
      { letter: 'C', text: "It doesn't matter what your password is, since a simple password is less likely to be forgotten" },
      { letter: 'D', text: "Strong passwords are only for adults, since you're the only one who ever logs in here" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-018",
    text: "When you visit a website and it says 'This site uses cookies,' what are cookies?",
    options: [
      { letter: 'A', text: "Actual snacks or treats that the website sends to you, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Photos saved directly to your local hard drive, since that approach works for similar problems" },
      { letter: 'C', text: "Harmful computer viruses — programs that damage devices, since it covers the most important part of the answer" },
      { letter: 'D', text: "Small files that track what you do on the website, like pages you visit and items you click on" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-019",
    text: "A smart speaker in your home is always listening for its wake word. Why does this matter for privacy?",
    options: [
      { letter: 'A', text: "Smart speakers can't hear anything, since the benefits of new technology always outweigh the risks" },
      { letter: 'B', text: "Smart speakers only listen when they are turned off, since technology designed to help can't cause real harm" },
      { letter: 'C', text: "Privacy doesn't matter at home, since widespread adoption means the technology has been proven safe" },
      { letter: 'D', text: "It could record conversations by accident, so it's important to know what data your devices collect" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-020",
    text: "Why should you be careful when using an unsecured (no password) Wi-Fi network?",
    options: [
      { letter: 'A', text: "Unsecured networks are always the safest, since complexity makes passwords impossible to remember without writing them down" },
      { letter: 'B', text: "Wi-Fi security never matters at all, since you're the only one who ever logs in here" },
      { letter: 'C', text: "Unsecured networks are faster than secured ones, since a simple password is less likely to be forgotten" },
      { letter: 'D', text: "Others on the same network may be able to see what you type, including passwords and personal info" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-021",
    text: "A classmate sends you repeated mean messages online. What is the BEST way to respond?",
    options: [
      { letter: 'A', text: "Don't reply — save the messages as proof and tell a trusted adult" },
      { letter: 'B', text: "Send mean messages back, since it was probably meant as a joke" },
      { letter: 'C', text: "Delete your account so they can't find you, since online actions feel less harmful than face-to-face ones" },
      { letter: 'D', text: "Share the messages with the whole class, since blocking the person solves the problem completely" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-022",
    text: "You see someone being bullied in an online game. What does it mean to 'advocate for others'?",
    options: [
      { letter: 'A', text: "Join the bullying since everyone else is" },
      { letter: 'B', text: "Ignore it — it's not your problem, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "Speak up to support the person being bullied, report the behavior, and tell a trusted adult" },
      { letter: 'D', text: "Leave the game and never play again, since that approach works for similar problems" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-023",
    text: "What does 'advocating for yourself' mean when you are being cyberbullied?",
    options: [
      { letter: 'A', text: "Fighting back with mean messages online, since blocking the person solves the problem completely" },
      { letter: 'B', text: "Keeping it a secret and hoping it stops, since online actions feel less harmful than face-to-face ones" },
      { letter: 'C', text: "Speaking up by telling a trusted adult, blocking the bully, and saving proof of what happened" },
      { letter: 'D', text: "Switching to a completely different school, since it was probably meant as a joke" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-PT-001",
    text: "You need to make a chart showing how many students like each sport. Which app is BEST?",
    options: [
      { letter: 'A', text: "A music player, since any program can handle the task with a little extra work" },
      { letter: 'B', text: "A basic calculator — only for simple arithmetic, since that tool handles similar tasks just as well" },
      { letter: 'C', text: "A spreadsheet app that can make charts" },
      { letter: 'D', text: "A camera or photo app, since knowing a tool well makes up for it not being ideal" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-002",
    text: "Your teacher asks you to write a research report with paragraphs and headings. Which app should you choose?",
    options: [
      { letter: 'A', text: "A drawing or paint app, since that tool handles similar tasks just as well" },
      { letter: 'B', text: "A word processing app like Google Docs" },
      { letter: 'C', text: "A video editing app, since knowing a tool well makes up for it not being ideal" },
      { letter: 'D', text: "A music creation app, since any program can handle the task with a little extra work" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-003",
    text: "You want to show your class a slideshow about the water cycle with pictures and text on each slide. Which app is BEST?",
    options: [
      { letter: 'A', text: "A spreadsheet — used for organizing numbers and data, since that tool handles similar tasks just as well" },
      { letter: 'B', text: "A basic calculator — only for simple arithmetic, since any program can handle the task with a little extra work" },
      { letter: 'C', text: "A word processor — used for writing and editing text, since knowing a tool well makes up for it not being ideal" },
      { letter: 'D', text: "A presentation app like Google Slides or PowerPoint" }
    ],
    correctAnswer: "D",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-004",
    text: "A student wants to organize her report with a numbered list of steps. Which tool should she use?",
    options: [
      { letter: 'A', text: "The font color tool for changing text color, since that tool handles similar tasks just as well" },
      { letter: 'B', text: "The numbered list button in her word processor" },
      { letter: 'C', text: "Press the Print button on the toolbar, since knowing a tool well makes up for it not being ideal" },
      { letter: 'D', text: "Press the Delete button to remove text, since any program can handle the task with a little extra work" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-005",
    text: "When should you use bullet points in a document?",
    options: [
      { letter: 'A', text: "Never — bullets make documents look messy, since that approach works for similar problems" },
      { letter: 'B', text: "For every sentence in the entire document, since it covers the most important part of the answer" },
      { letter: 'C', text: "When you have a list of items or ideas that don't need to be in a specific order" },
      { letter: 'D', text: "Only useful for math homework assignments, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-006",
    text: "A student typed 'teh' instead of 'the' 12 times in her report. Which editing tool fixes all 12 at once?",
    options: [
      { letter: 'A', text: "Find and Replace — search for 'teh' and replace it" },
      { letter: 'B', text: "Delete the whole document and start over, since that tool handles similar tasks just as well" },
      { letter: 'C', text: "Read the entire document and fix each one by hand, since knowing a tool well makes up for it not being ideal" },
      { letter: 'D', text: "Change the font so the errors aren't visible, since any program can handle the task with a little extra work" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-007",
    text: "What is video conferencing?",
    options: [
      { letter: 'A', text: "Watching a movie alone on your tablet, since that approach works for similar problems" },
      { letter: 'B', text: "A way to have a meeting with people in different places using video and audio over the internet" },
      { letter: 'C', text: "A type of video game — not a cyberbullying term, since it covers the most important part of the answer" },
      { letter: 'D', text: "Sending a letter through the mail, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-008",
    text: "Augmented reality (AR) adds digital images on top of the real world — like a phone app that shows virtual animals in your actual classroom. What makes AR different from virtual reality (VR)?",
    options: [
      { letter: 'A', text: "AR adds to the real world you can still see; VR replaces the real world with a completely digital one" },
      { letter: 'B', text: "AR and VR are the same thing, since the benefits of new technology always outweigh the risks" },
      { letter: 'C', text: "VR adds to the real world; AR replaces it, since widespread adoption means the technology has been proven safe" },
      { letter: 'D', text: "Neither AR nor VR uses technology, since technology designed to help can't cause real harm" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-009",
    text: "What is virtual reality (VR)?",
    options: [
      { letter: 'A', text: "A regular video on a computer screen, since the benefits of new technology always outweigh the risks" },
      { letter: 'B', text: "A printed poster that looks 3D, since widespread adoption means the technology has been proven safe" },
      { letter: 'C', text: "A type of phone call — not a computer security term, since technology designed to help can't cause real harm" },
      { letter: 'D', text: "A technology that puts you inside a completely computer-made world, usually using a headset" }
    ],
    correctAnswer: "D",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-010",
    text: "A student names her files 'stuff1,' 'stuff2,' and 'stuff3.' Why is this a problem?",
    options: [
      { letter: 'A', text: "Short names are always best, since any folder name works if you remember it" },
      { letter: 'B', text: "The names don't describe what's inside, so she'll have trouble finding the right file later" },
      { letter: 'C', text: "Numbers in file names cause computers to crash, since deleting old files keeps storage from filling up" },
      { letter: 'D', text: "There is no problem with these names, since the computer's search finds any file regardless of location" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-011",
    text: "Where is the BEST place to save your school project files?",
    options: [
      { letter: 'A', text: "On the desktop with no folder, since the computer's search finds any file regardless of location" },
      { letter: 'B', text: "In a folder with a clear name like 'Science_Projects' inside a 'School' folder" },
      { letter: 'C', text: "Anywhere — it doesn't matter where you save, since any folder name works if you remember it" },
      { letter: 'D', text: "Delete them after you're done so they don't take up space, since deleting old files keeps storage from filling up" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-012",
    text: "Which file name is BEST for a math project about fractions?",
    options: [
      { letter: 'A', text: "asdfghjkl, since the computer's search finds any file regardless of location" },
      { letter: 'B', text: "New Document (1), since any folder name works if you remember it" },
      { letter: 'C', text: "file" },
      { letter: 'D', text: "Math_Fractions_Project_2026" }
    ],
    correctAnswer: "D",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-013",
    text: "What does 'ergonomic' mean when typing?",
    options: [
      { letter: 'A', text: "Typing as fast as possible no matter how you sit, since one finger at a time reduces typos" },
      { letter: 'B', text: "Using body positions that are comfortable and healthy — like sitting up straight, feet flat, wrists level" },
      { letter: 'C', text: "Only typing with one finger, since speed matters more than finger placement" },
      { letter: 'D', text: "Leaning back as far as possible, since any posture works if you stay comfortable" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-014",
    text: "Why is it important to practice keyboarding with BOTH speed AND accuracy?",
    options: [
      { letter: 'A', text: "Only speed matters — errors don't count, since speed matters more than finger placement" },
      { letter: 'B', text: "Typing fast with many errors wastes time fixing mistakes; good keyboarding means being both quick and correct" },
      { letter: 'C', text: "Only accuracy matters — speed is not important, since any posture works if you stay comfortable" },
      { letter: 'D', text: "Keyboarding practice is not needed anymore because of voice typing" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-015",
    text: "In math class, you need to type the division symbol ÷. Where can you find special symbols on a keyboard?",
    options: [
      { letter: 'A', text: "They don't exist on computers, since speed matters more than finger placement" },
      { letter: 'B', text: "You have to draw them by hand, since one finger at a time reduces typos" },
      { letter: 'C', text: "Only calculators have math symbols, since any posture works if you stay comfortable" },
      { letter: 'D', text: "Use the Insert Symbol menu or learn the keyboard shortcut for the symbol you need" }
    ],
    correctAnswer: "D",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-016",
    text: "A student needs to type the degree symbol (°) for a science report about temperature. What should she do?",
    options: [
      { letter: 'A', text: "Write the word 'degrees' every time — there's no way to type the symbol, since it covers the most important part of the answer" },
      { letter: 'B', text: "Draw a little circle by hand on the printed page, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "Use the Insert Symbol menu or a keyboard shortcut to type ° directly into the document" },
      { letter: 'D', text: "Skip the symbol and hope the teacher doesn't notice, since that approach works for similar problems" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-017",
    text: "A program on your computer freezes and won't respond. What should you try FIRST?",
    options: [
      { letter: 'A', text: "Close the frozen program and reopen it" },
      { letter: 'B', text: "Throw the computer away, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "Pour water on the keyboard, since it covers the most important part of the answer" },
      { letter: 'D', text: "Hit the screen, since that approach works for similar problems" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-018",
    text: "Your mouse stops working. What is a good first troubleshooting step?",
    options: [
      { letter: 'A', text: "Buy a brand new computer right away, since that approach works for similar problems" },
      { letter: 'B', text: "Delete all your saved files and documents, since that step seems unnecessary in this situation" },
      { letter: 'C', text: "Check if the mouse is plugged in or if the batteries are dead, then try unplugging and replugging it" },
      { letter: 'D', text: "Ignore it and use only the keyboard forever, since it covers the most important part of the answer" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-019",
    text: "Your computer is running very slowly. What should you try?",
    options: [
      { letter: 'A', text: "Close programs you're not using — too many open programs can slow your computer down" },
      { letter: 'B', text: "Open even more programs to speed it up, since it covers the most important part of the answer" },
      { letter: 'C', text: "Turn off the monitor, since that approach works for similar problems" },
      { letter: 'D', text: "The computer is broken and can never be fixed, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-020",
    text: "You saved a file but can't find it on your computer. What should you try?",
    options: [
      { letter: 'A', text: "The file is gone forever, since deleting old files keeps storage from filling up" },
      { letter: 'B', text: "Use the search bar to look for the file name" },
      { letter: 'C', text: "Delete everything and start over, since the computer's search finds any file regardless of location" },
      { letter: 'D', text: "Buy a brand new computer right away, since any folder name works if you remember it" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-DL-013",
    text: "A student wants to show her class how much rain fell each month. Which is the BEST way to display this?",
    options: [
      { letter: 'A', text: "Write all the numbers in one long sentence, since that step seems unnecessary in this situation" },
      { letter: 'B', text: "Memorize the numbers and say them out loud, since that approach works for similar problems" },
      { letter: 'C', text: "Make a bar graph with months on the bottom and rain amounts on the side" },
      { letter: 'D', text: "Draw a picture of rain clouds, since it covers the most important part of the answer" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-4-CI-010",
    text: "A student is stuck on a design project. She asks: 'What if I try a different material?' and 'What would happen if I made it smaller?' Which skill is she using?",
    options: [
      { letter: 'A', text: "Giving up — stopping without trying further, since it covers the most important part of the answer" },
      { letter: 'B', text: "Blaming the materials for the failure, since that approach works for similar problems" },
      { letter: 'C', text: "Questioning — asking 'what if' questions to find new solutions" },
      { letter: 'D', text: "Copying from a classmate's finished work, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-4-DC-024",
    text: "Your team is on a video call to plan a project. Which behavior is the BEST example of collaboration etiquette?",
    options: [
      { letter: 'A', text: "Talking over everyone to share your ideas first, since jumping in shows you the real problems faster" },
      { letter: 'B', text: "Leaving the call early without telling anyone, since planning wastes time you could spend building" },
      { letter: 'C', text: "Playing a game on another tab during the meeting, since you can adjust the steps as you go" },
      { letter: 'D', text: "Listening when others talk, waiting your turn, and building on their ideas" }
    ],
    correctAnswer: "D",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-025",
    text: "A pop-up appears on a website saying 'Click here to win a free tablet!' What should you do?",
    options: [
      { letter: 'A', text: "Click it right away to claim the prize, since legitimate offers do sometimes appear unexpectedly" },
      { letter: 'B', text: "Enter your home address so they can mail the tablet, since the message looks official enough to trust" },
      { letter: 'C', text: "Close the pop-up without clicking — these are often tricks to collect your personal information" },
      { letter: 'D', text: "Share the link with all your friends, since the message looks official enough to trust" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-CT-019",
    text: "A program needs to print 'Good job!' 20 times. A student writes the print command 20 separate times. What is a BETTER way?",
    options: [
      { letter: 'A', text: "Write it 40 times to be safe, since it covers the most important part of the answer" },
      { letter: 'B', text: "Delete the entire program and start over, since that approach works for similar problems" },
      { letter: 'C', text: "Use a loop that repeats the print command 20 times — same result with much less code" },
      { letter: 'D', text: "Only print it once and hope that's enough, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-4-DC-026",
    text: "Your friend sends you a text message with exciting news. Which reply shows good digital etiquette?",
    options: [
      { letter: 'A', text: "Don't reply at all, since that behavior is common in casual video calls" },
      { letter: 'B', text: "Reply with kind words: 'That's awesome! I'm happy for you!'" },
      { letter: 'C', text: "Reply with ALL CAPS: 'WHATEVER I DON'T CARE', since muting when not speaking seems optional, not required" },
      { letter: 'D', text: "Forward the message to others without asking, since multitasking during a meeting is normal" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-027",
    text: "A classmate tells you a trick to get around the school's website filter. What should you do?",
    options: [
      { letter: 'A', text: "Try the trick right away immediately, since that approach works for similar problems" },
      { letter: 'B', text: "Tell all your friends about the trick, since it covers the most important part of the answer" },
      { letter: 'C', text: "Explain that breaking the AUP rules could get both of you in trouble and it's not worth the risk" },
      { letter: 'D', text: "Use it only when the teacher isn't looking, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-DC-028",
    text: "You used a fact from a website AND a picture from a different website in your project. How many citations do you need?",
    options: [
      { letter: 'A', text: "Zero — internet sources don't need citations, since changing a few details makes it your own work" },
      { letter: 'B', text: "One — just cite whichever source is more important, since school projects are usually exempt from copyright rules" },
      { letter: 'C', text: "Two — every source you use needs its own citation" },
      { letter: 'D', text: "Only the picture needs a citation, since you're not selling it or making money" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-4-PT-021",
    text: "A student types 20 words per minute with lots of errors. Her teacher says to slow down. Why?",
    options: [
      { letter: 'A', text: "Slower typing is always better, since speed matters more than finger placement" },
      { letter: 'B', text: "Typing accurately is more important than speed — she should build accuracy first, then work on increasing speed" },
      { letter: 'C', text: "The teacher wants her to take longer on assignments, since any posture works if you stay comfortable" },
      { letter: 'D', text: "Speed doesn't matter at all, since one finger at a time reduces typos" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-4-PT-022",
    text: "In a science report, you need to type the percent symbol (%). The % is above the 5 key. How do you type it?",
    options: [
      { letter: 'A', text: "Press 5 by itself, since that approach works for similar problems" },
      { letter: 'B', text: "Press the space bar, since it covers the most important part of the answer" },
      { letter: 'C', text: "Hold Shift and press 5" },
      { letter: 'D', text: "Type the word 'percent' — there's no symbol on the keyboard, since that step seems unnecessary in this situation" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  }
];
